var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375.67 386.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5d9e8;\n      }\n\n      .cls-2 {\n        fill: #f7f052;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-1",
    d: "M178.33,0H162L89,210,18,0H0L79.33,233.33h18L170,24l43.77,126.67h16.62Zm53,153.33H214.69L219.76,168h16.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-2",
    d: "M289.67,372h-87V275.67h87c44.66,0,69,14.66,69,48,0,33.66-24.34,48.33-69,48.33m34.66-105.67c23.34-7.66,39-25.66,39-53.33,0-36.77-27.44-57.57-73.14-59.52L285.25,168c38.54.74,60.75,16.38,60.75,46.3,0,31-23.33,46.67-63.67,46.67H202.67V168h59.94l5-14.67H185.67V386.67h104c57.33,0,86-22.34,86-61.67,0-32.33-18.34-52.33-51.34-58.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "cls-1",
    d: "M339.33,0l-51,150.75-.89,2.65L282.45,168l-.9,2.67-21.22,62.66h-18l-21.65-62.66h16.61L251,210.33l13.52-39.66.91-2.67,5-14.67.9-2.66L322.67,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-2",
    d: "M128,310a38,38,0,1,1-38-38,38,38,0,0,1,38,38"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a855b2d5e0f2f3602da639dfecf7408a.svg";
export { ForwardRef as ReactComponent };